import { useState, useEffect } from 'react';
import partition from 'lodash/partition';

// useEventState Custom Hook
//
// Partitions all events into today and upcoming event sets on allEvents or selectedDate change.
// Returns { todayEvents, upcomingEvents, eventsExistOnDay }
const useEventsState = (allEvents, selectedISODate) => {
  const [eventsState, setEventsState] = useState({ todayEvents: [], upcomingEvents: [], eventsExistOnDay: false });
  useEffect(() => {
    if (!(allEvents && allEvents.length)) { return; }
    const [todayEvents, upcomingEvents] = partition(allEvents, (event) => event?.date === selectedISODate);
    setEventsState({ todayEvents, upcomingEvents, eventsExistOnDay: todayEvents.length > 0 });
  }, [allEvents, selectedISODate]);

  const { todayEvents, upcomingEvents, eventsExistOnDay } = eventsState;
  return { todayEvents, upcomingEvents, eventsExistOnDay };
};

export default useEventsState;
